import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const GET_LAYOUT_REQUEST = 'GET_LAYOUT_REQUEST';
export const GET_LAYOUT_SUCCESS = 'GET_LAYOUT_SUCCESS';
export const GET_LAYOUT_ERROR = 'GET_LAYOUT_ERROR';

export function fetchLayout(newLayout, requestHeaders) {
	return ApiCaller.get(
		Object.assign({}, baseAjaxConfig, {
			pathname: `/api/3/layout/${newLayout}`,
			action: GET_LAYOUT_REQUEST,
			headers: Object.assign({}, headers, requestHeaders)
		})
	);
}
